import { render, staticRenderFns } from "./addNewDialog.vue?vue&type=template&id=71eb5940&"
import script from "./addNewDialog.vue?vue&type=script&lang=ts&"
export * from "./addNewDialog.vue?vue&type=script&lang=ts&"
import style0 from "./addNewDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports